import { c as _c } from "react/compiler-runtime";
import { ActionIcon } from '@mantine/core';
import { CommentsStats } from 'components/discussion/Comments';
import { useState } from 'react';
import { HiDocumentText } from 'react-icons/hi';
import { useWindowDim } from 'shared/ui';
import { tourTipProps } from './tourTypes';
export const useScreenMode = () => {
  const $ = _c(3);
  const {
    w
  } = useWindowDim();
  const [mode, setMode] = useState("form");
  const modal = w < 600;
  let t0;
  if ($[0] !== modal || $[1] !== mode) {
    t0 = {
      mode,
      modal,
      setMode
    };
    $[0] = modal;
    $[1] = mode;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export type UseScreenMode = ReturnType<typeof useScreenMode>;
export const ScreenModeButton = t0 => {
  const $ = _c(7);
  const {
    mode,
    modal,
    total,
    unread,
    setMode
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = tourTipProps("comment-toggle-modal");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const iconProps = t1;
  let t2;
  if ($[1] !== modal || $[2] !== mode || $[3] !== setMode || $[4] !== total || $[5] !== unread) {
    t2 = modal ? mode == "form" ? <ActionIcon {...iconProps} title="switch to comment view" onClick={() => setMode("comments")} styles={{
      root: {
        overflow: "visible"
      }
    }}><CommentsStats {...{
        total,
        unread
      }} /></ActionIcon> : <ActionIcon {...iconProps} title="switch to question view" onClick={() => setMode("form")}><HiDocumentText size="18px" /></ActionIcon> : <></>;
    $[1] = modal;
    $[2] = mode;
    $[3] = setMode;
    $[4] = total;
    $[5] = unread;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};